export default __webpack_public_path__ + "static/media/SSENSE.1990f83a.png";